import PaymentErrorsFactory from '../Errors/factory.js'
import PriceValueObject from './PriceValueObject.js'
import TaxValueObject from './TaxValueObject.js'

export default class PaymentValueObjectsFactory {
  static priceValueObject = ({value, amountLabelValue, currency}) => {
    PriceValueObject.validate({
      InvalidPriceErrorFactory: PaymentErrorsFactory.invalidPriceError,
      value,
      amountLabelValue,
      currency
    })
    return new PriceValueObject({value, amountLabelValue, currency})
  }

  static taxValueObject = ({type, percentage, amount, amountLabelValue}) => {
    TaxValueObject.validate({
      InvalidTaxErrorFactory: PaymentErrorsFactory.invalidTaxError,
      type,
      percentage,
      amount,
      amountLabelValue
    })
    return new TaxValueObject({type, percentage, amount, amountLabelValue})
  }
}
